// Framework-freie Mini-i18n des SDK (kein next-intl — läuft als Vanilla-Snippet
// in fremden Seiten). Nur probanden-sichtbare Widget-Texte (Fragen-Modal,
// Element-Feedback). Neue Sprache = Eintrag in MESSAGES + normalizeLocale.

export type SdkLocale = "de" | "en";

const MESSAGES = {
  de: {
    "questions.preTitle": "Kurze Fragen vorab",
    "questions.endTitle": "Abschlussfragen",
    "questions.next": "Weiter",
    "questions.submit": "Absenden",
    "questions.finish": "✓ Befragung abschließen",
    "questions.thanks": "Danke für dein Feedback!",
    "comments.feedback": "Feedback",
    "comments.hint": "Auf ein Element ziehen & klicken, um Feedback zu setzen — Esc bricht ab",
    "comments.placeholder": "Kommentar hinzufügen",
  },
  en: {
    "questions.preTitle": "A few quick questions first",
    "questions.endTitle": "Final questions",
    "questions.next": "Next",
    "questions.submit": "Submit",
    "questions.finish": "✓ Finish survey",
    "questions.thanks": "Thanks for your feedback!",
    "comments.feedback": "Feedback",
    "comments.hint": "Drag onto an element & click to leave feedback — Esc to cancel",
    "comments.placeholder": "Add a comment",
  },
} as const;

export type MsgKey = keyof (typeof MESSAGES)["de"];
export type Translate = (key: MsgKey) => string;

const DEFAULT_LOCALE: SdkLocale = "de";

/** "de-DE", "EN", "en-US" → "de"/"en"; unbekannt → undefined. */
export function normalizeLocale(input?: string | null): SdkLocale | undefined {
  if (!input) return undefined;
  const l = input.toLowerCase();
  if (l.startsWith("de")) return "de";
  if (l.startsWith("en")) return "en";
  return undefined;
}

/**
 * Locale auflösen — „Auto + Override":
 * explizit (init.locale / data-locale) > config (study.locale vom Relay) >
 * navigator.language (Auto) > "de".
 */
export function resolveLocale(opts: { explicit?: string; config?: string }): SdkLocale {
  return (
    normalizeLocale(opts.explicit) ??
    normalizeLocale(opts.config) ??
    (typeof navigator !== "undefined" ? normalizeLocale(navigator.language) : undefined) ??
    DEFAULT_LOCALE
  );
}

/** Übersetzer-Funktion für ein Locale (Fallback auf DE bei fehlendem Key). */
export function makeT(locale: SdkLocale): Translate {
  return (key) => MESSAGES[locale][key] ?? MESSAGES[DEFAULT_LOCALE][key];
}
